// extracted by mini-css-extract-plugin
module.exports = {"mainchip":"stdassignmentsidebar_mainchip__3YF7f","green":"stdassignmentsidebar_green__pf0J8"};